// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * An audit log entry recording a user action.
 */
export class Audit implements flatbuffers.IUnpackableObject<AuditT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Audit {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAudit(bb: flatbuffers.ByteBuffer, obj?: Audit): Audit {
    return (obj || new Audit()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsAudit(bb: flatbuffers.ByteBuffer, obj?: Audit): Audit {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Audit()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  action(): string | null;
  action(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  action(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  email(): string | null;
  email(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  email(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  userId(): string | null;
  userId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  userId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  organizationId(): string | null;
  organizationId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  organizationId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  tableName(): string | null;
  tableName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  tableName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  valueId(): string | null;
  valueId(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  valueId(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  oldValue(): string | null;
  oldValue(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  oldValue(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startAudit(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addAction(builder: flatbuffers.Builder, actionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, actionOffset, 0);
  }

  static addEmail(builder: flatbuffers.Builder, emailOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, emailOffset, 0);
  }

  static addUserId(builder: flatbuffers.Builder, userIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, userIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, organizationIdOffset, 0);
  }

  static addTableName(builder: flatbuffers.Builder, tableNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, tableNameOffset, 0);
  }

  static addValueId(builder: flatbuffers.Builder, valueIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, valueIdOffset, 0);
  }

  static addOldValue(builder: flatbuffers.Builder, oldValueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, oldValueOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, updatedAtOffset, 0);
  }

  static endAudit(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createAudit(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    actionOffset: flatbuffers.Offset,
    emailOffset: flatbuffers.Offset,
    userIdOffset: flatbuffers.Offset,
    organizationIdOffset: flatbuffers.Offset,
    tableNameOffset: flatbuffers.Offset,
    valueIdOffset: flatbuffers.Offset,
    oldValueOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Audit.startAudit(builder);
    Audit.addId(builder, idOffset);
    Audit.addAction(builder, actionOffset);
    Audit.addEmail(builder, emailOffset);
    Audit.addUserId(builder, userIdOffset);
    Audit.addOrganizationId(builder, organizationIdOffset);
    Audit.addTableName(builder, tableNameOffset);
    Audit.addValueId(builder, valueIdOffset);
    Audit.addOldValue(builder, oldValueOffset);
    Audit.addCreatedAt(builder, createdAtOffset);
    Audit.addUpdatedAt(builder, updatedAtOffset);
    return Audit.endAudit(builder);
  }

  unpack(): AuditT {
    return new AuditT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.action(),
      this.email(),
      this.userId(),
      this.organizationId(),
      this.tableName(),
      this.valueId(),
      this.oldValue(),
      this.createdAt(),
      this.updatedAt(),
    );
  }

  unpackTo(_o: AuditT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.action = this.action();
    _o.email = this.email();
    _o.userId = this.userId();
    _o.organizationId = this.organizationId();
    _o.tableName = this.tableName();
    _o.valueId = this.valueId();
    _o.oldValue = this.oldValue();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
  }

  unpackFields(...fields: string[]): AuditT {
    const t = new AuditT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("action")) {
      t.action = this.action();
    }
    if (fieldSet.has("email")) {
      t.email = this.email();
    }
    if (fieldSet.has("user_id")) {
      t.userId = this.userId();
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId();
    }
    if (fieldSet.has("table_name")) {
      t.tableName = this.tableName();
    }
    if (fieldSet.has("value_id")) {
      t.valueId = this.valueId();
    }
    if (fieldSet.has("old_value")) {
      t.oldValue = this.oldValue();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    return t;
  }
}

export class AuditT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public action: string | Uint8Array | null = null,
    public email: string | Uint8Array | null = null,
    public userId: string | Uint8Array | null = null,
    public organizationId: string | Uint8Array | null = null,
    public tableName: string | Uint8Array | null = null,
    public valueId: string | Uint8Array | null = null,
    public oldValue: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const action = this.action !== null ? builder.createString(this.action!) : 0;
    const email = this.email !== null ? builder.createString(this.email!) : 0;
    const userId = this.userId !== null ? builder.createString(this.userId!) : 0;
    const organizationId =
      this.organizationId !== null ? builder.createString(this.organizationId!) : 0;
    const tableName = this.tableName !== null ? builder.createString(this.tableName!) : 0;
    const valueId = this.valueId !== null ? builder.createString(this.valueId!) : 0;
    const oldValue = this.oldValue !== null ? builder.createString(this.oldValue!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    return Audit.createAudit(
      builder,
      id,
      action,
      email,
      userId,
      organizationId,
      tableName,
      valueId,
      oldValue,
      createdAt,
      updatedAt,
    );
  }

  clone(): AuditT {
    const obj = new AuditT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.action = this.action;
    obj.email = this.email;
    obj.userId = this.userId;
    obj.organizationId = this.organizationId;
    obj.tableName = this.tableName;
    obj.valueId = this.valueId;
    obj.oldValue = this.oldValue;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    return obj;
  }

  equals(other: AuditT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.action !== other.action) return false;
    if (this.email !== other.email) return false;
    if (this.userId !== other.userId) return false;
    if (this.organizationId !== other.organizationId) return false;
    if (this.tableName !== other.tableName) return false;
    if (this.valueId !== other.valueId) return false;
    if (this.oldValue !== other.oldValue) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    return true;
  }
}

export function verifyAudit(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
